import i18n, { API_NAMESPACE } from '@/i18n';

const LEGACY_ERROR_MAP: Record<string, string> = {
  'Falha ao criar sessão de liveness': 'LIVENESS_SESSION_CREATE_FAILED',
  'Falha ao validar liveness': 'LIVENESS_VALIDATION_FAILED',
  'Sessão de liveness ainda não concluída': 'LIVENESS_SESSION_PENDING',
  'Verificação de liveness não concluída com sucesso': 'LIVENESS_VERIFICATION_FAILED',
  'base64Image obrigatório': 'BASE64_IMAGE_REQUIRED',
  'sessionId obrigatório': 'SESSION_ID_REQUIRED',
  'Falha ao criar conta': 'FAILED_TO_CREATE_ACCOUNT',
  'Conta criada com sucesso': 'ACCOUNT_CREATED',
  'CPF inválido': 'CPF_INVALID',
  'Failed to create account': 'FAILED_TO_CREATE_ACCOUNT',
  'Failed to load consent documents': 'FAILED_TO_LOAD_CONSENT',
  'Failed to register consent': 'FAILED_TO_REGISTER_CONSENT',
  'Failed to submit selfie': 'FAILED_TO_SUBMIT_SELFIE',
  'sessionId is required': 'SESSION_ID_REQUIRED_PROFILE',
  'Failed to load user profile': 'FAILED_TO_LOAD_PROFILE',
  'Falha ao buscar dados do serviço externo': 'EXTERNAL_SERVICE_FAILED',
  'Tenant slug is required': 'TENANT_SLUG_REQUIRED',
  'Tenant branding not found': 'TENANT_BRANDING_NOT_FOUND',
  'Failed to load tenant branding': 'FAILED_TO_LOAD_BRANDING',
  'Event slug is required': 'EVENT_SLUG_REQUIRED',
  'Event not found': 'EVENT_NOT_FOUND',
  'Failed to load event context': 'FAILED_TO_LOAD_EVENT',
  'Guest not found in event guest list': 'GUEST_NOT_IN_EVENT',
  'Guest already completed the biometric onboarding': 'GUEST_ALREADY_ONBOARDED',
  'Rota não encontrada': 'ROUTE_NOT_FOUND',
  'Rota de API não encontrada': 'API_ROUTE_NOT_FOUND',
  'Erro interno do servidor': 'INTERNAL_SERVER_ERROR',
  'Invalid email': 'INVALID_EMAIL',
  'fullName must have at least 2 characters': 'FULL_NAME_TOO_SHORT',
  'O documento deve ter no mínimo 6 caracteres': 'DOCUMENT_MIN_LENGTH',
  'consentGiven must be true': 'CONSENT_GIVEN_REQUIRED',
  'acceptedTerms must be true': 'ACCEPTED_TERMS_REQUIRED',
  'acceptedPrivacy must be true': 'ACCEPTED_PRIVACY_REQUIRED',
  'Invalid consent payload': 'INVALID_CONSENT_PAYLOAD',
  'Invalid guardian email': 'INVALID_GUARDIAN_EMAIL',
  'guardianPhone must have at least 10 digits': 'GUARDIAN_PHONE_TOO_SHORT',
  'Invalid guardianRelationship': 'INVALID_GUARDIAN_RELATIONSHIP',
  'Invalid signup payload': 'INVALID_SIGNUP_PAYLOAD',
  'Consent registered successfully': 'CONSENT_REGISTERED',
  'Failed to create liveness session': 'LIVENESS_SESSION_CREATE_FAILED',
  'Failed to validate liveness': 'LIVENESS_VALIDATION_FAILED',
  'Liveness session not yet completed': 'LIVENESS_SESSION_PENDING',
  'Liveness verification did not succeed': 'LIVENESS_VERIFICATION_FAILED',
  'base64Image is required': 'BASE64_IMAGE_REQUIRED',
  'Failed to fetch data from external service': 'EXTERNAL_SERVICE_FAILED',
  'Route not found': 'ROUTE_NOT_FOUND',
  'API route not found': 'API_ROUTE_NOT_FOUND',
  'Internal server error': 'INTERNAL_SERVER_ERROR',
};

function translateErrorCode(
  code: string,
  options?: { min?: number },
): string | null {
  const translated = i18n.t(`errors.${code}`, {
    ns: API_NAMESPACE,
    defaultValue: '',
    ...(options?.min !== undefined ? { min: options.min } : {}),
  });
  return translated !== '' ? translated : null;
}

function resolveErrorCode(message: string): { code: string; min?: number } | null {
  if (message in LEGACY_ERROR_MAP) {
    return { code: LEGACY_ERROR_MAP[message] as string };
  }

  const confidenceMatch = /^Confiança de liveness abaixo do mínimo \((\d+)\)$/.exec(
    message,
  );
  if (confidenceMatch?.[1]) {
    return {
      code: 'LIVENESS_CONFIDENCE_LOW',
      min: Number(confidenceMatch[1]),
    };
  }

  const confidenceEnMatch = /^Liveness confidence below minimum \((\d+)\)$/.exec(
    message,
  );
  if (confidenceEnMatch?.[1]) {
    return {
      code: 'LIVENESS_CONFIDENCE_LOW',
      min: Number(confidenceEnMatch[1]),
    };
  }

  if (/^[A-Z0-9_]+$/.test(message)) {
    return { code: message };
  }

  return null;
}

export function translateApiError(
  message: string,
  options?: { min?: number },
): string {
  const resolved = resolveErrorCode(message);
  if (resolved !== null) {
    const translated = translateErrorCode(resolved.code, {
      ...(resolved.min !== undefined ? { min: resolved.min } : {}),
      ...options,
    });
    if (translated !== null) {
      return translated;
    }
  }

  return message;
}

export function translateApiErrorStatus(status: number): string {
  return i18n.t('genericApiError', {
    ns: 'common',
    status,
  });
}
